export default {
  VARIABLES: {
    tableinSidebarOpen: 'tableinSidebarOpen',
    tableinCalendarDisplay: 'tableinCalendarDisplay',
    tableinCalendarDayStart: 'tableinCalendarDayStart',
    showDaysLength: 7,
    paginationLimit: 10,
  }
}
